import instance from 'api';
import { IDynamicTableParams } from 'components/DynamicTable';
import {
  IArea,
  IDefectReason,
  IServiceOrg,
  IMailingType,
  INewReceiverPosition,
  IRealEstate,
  IReceiver,
} from './interfaces';

export const getMailingTypes = () => {
  return instance()
    .post<IMailingType[]>('/dictionary/mailingTypes')
    .then((response) => response.data);
};

export const getMailReceiverAvailableColumns = () => {
  return instance()
    .post('/mailReceiver/availableColumns')
    .then((response) => response.data);
};

export const getMailReceiverAvailableGroupColumns = () => {
  return instance()
    .post('/mailReceiver/availableGroupColumns')
    .then((response) => response.data);
};

export const loadMailReceiver = (receiverId: number) => {
  return instance()
    .get<IReceiver>('/mailReceiver/load/' + receiverId)
    .then((response) => response.data);
};

export const addMailReceiver = (receiver: IReceiver) => {
  return instance()
    .post('/mailReceiver/add', receiver)
    .then((response) => response.data);
};

export const updateMailReceiver = (receiver: IReceiver) => {
  return instance()
    .post('/mailReceiver/update/' + receiver.weeklyReportReceiverId, receiver)
    .then((response) => response.data);
};

export const deleteMailReceiver = (receiverId: number) => {
  return instance()
    .post('/mailReceiver/delete', { receiverId })
    .then((response) => response.data);
};

export const getMailReceiversList = (data: IDynamicTableParams) => {
  return instance()
    .post('/mailReceiver/list', data)
    .then((response) => response.data);
};

export const getMailReceiverPositionAvailableColumns = () => {
  return instance()
    .post('/mailReceiverPosition/availableColumns')
    .then((response) => response.data);
};

export const getMailReceiverPositionAvailableGroupColumns = () => {
  return instance()
    .post('/mailReceiverPosition/availableGroupColumns')
    .then((response) => response.data);
};

export const addMailReceiverPosition = (receiver: INewReceiverPosition) => {
  return instance()
    .post('/mailReceiverPosition/add', receiver)
    .then((response) => response.data);
};

export const deleteMailReceiverPosition = (receiverId: number) => {
  return instance()
    .post('/mailReceiverPosition/delete', { receiverId })
    .then((response) => response.data);
};

export const getMailReceiverPositionsList = (data: IDynamicTableParams) => {
  return instance()
    .post('/mailReceiverPosition/list', data)
    .then((response) => response.data);
};

// dictionaries
export const getServiceOrgs = () => {
  return instance()
    .post<IServiceOrg[]>('/dictionary/serviceOrgs', {})
    .then((response) => response.data);
};

export const getAreas = () => {
  return instance()
    .post<IArea[]>('/area/list', {})
    .then((response) => response.data);
};

export const getRealEstatesShort = (
  data: { onlyFromMatrix?: boolean; searchWithCity?: boolean; nameWithCity?: boolean } = {
    onlyFromMatrix: true,
    searchWithCity: true,
    nameWithCity: true,
  },
) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/realEstatesShort', data)
    .then((response) => response.data);
};

export const getDefectReasons = () => {
  return instance()
    .post<IDefectReason[]>('/dictionary/defectReasons', {})
    .then((response) => response.data);
};
